var chunkMapping = {
	"134": [
		134
	],
	"138": [
		3138
	],
	"258": [
		3258
	],
	"294": [
		9294
	],
	"407": [
		4407
	],
	"527": [
		3527
	],
	"554": [
		6554
	],
	"606": [
		8606
	],
	"772": [
		4772
	],
	"814": [
		9814
	],
	"815": [
		815
	]
};
var idToExternalAndNameMapping = {
	"134": [
		"default",
		"./courseList",
		3616
	],
	"815": [
		"default",
		"./subjectList",
		3616
	],
	"3138": [
		"default",
		"./SchoolPage",
		7856
	],
	"3258": [
		"default",
		"./Lessons",
		3616
	],
	"3527": [
		"default",
		"./StudentPage",
		7856
	],
	"4407": [
		"default",
		"./HomePage",
		7856
	],
	"4772": [
		"default",
		"./Report",
		8989
	],
	"6554": [
		"default",
		"./ScoreCard",
		8989
	],
	"8606": [
		"default",
		"./TeacherPage",
		7856
	],
	"9294": [
		"default",
		"./StudentLogin",
		9104
	],
	"9814": [
		"default",
		"./ComingSoon",
		9104
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_modules__[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_modules__[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}